import React, {useEffect, useState} from 'react'

export const TimerCountdown = ({ seconds, timeOut, className }) => {

    const [totalSecondsLeft, setTotalSecondsLeft] = useState(seconds);
    const [minutesLeft, setMinutesLeft] = useState(getMinutes(seconds));
    const [secondsLeft, setSecondsLeft] = useState(getSeconds(seconds, getMinutes(seconds)));
    let intervalId = null
    function getMinutes (totalSecondsLeft) {
        if(totalSecondsLeft >= 60){
            return Math.floor(totalSecondsLeft / 60)
        }else {
            return ''
        }
    };

    function getSeconds (totalSecondsLeft, minutes) {
        let seconds;
        if(minutes > 0){
            seconds = totalSecondsLeft - minutes * 60;
        }else {
            seconds = totalSecondsLeft
        }

        return seconds >= 10 ? seconds : `0${seconds}`;
    }

    useEffect(() => {

        if (totalSecondsLeft < 0) {
            timeOut();
            return;
        }

        intervalId = setInterval(() => {
            setTotalSecondsLeft(totalSecondsLeft - 1);
            const minutes = getMinutes(totalSecondsLeft)
            const seconds = getSeconds(totalSecondsLeft, minutes);
            setMinutesLeft(minutes);
            setSecondsLeft(seconds);
        }, 1000)

        return () => clearInterval(intervalId);
    }, [totalSecondsLeft]);

    return (
        <span className={`${className} highlight-bold`}>{minutesLeft}:{secondsLeft}</span>
    );
};
